import { showToast } from '@/contexts/ToastContext';

export class ServerError {
  message: string = '';
  path: string = '';
}

export class ServerErrors {
  total: number;
  errors: ServerError[] = [];

  constructor(result: any, total: any) {
    if (result === 'Internal Server Error') {
      const err = new ServerError();
      err.message = result;
      this.errors.push(err);
    } else {
      if (result !== undefined && result !== null) {
        for (const k in result) {
          if ((this as any)[k] !== undefined) {
            (this as any)[k] = result[k];
          }
        }
      }
    }
    this.total = total;
  }

  displayErrors(): void {
    const errorMessages: string[] = [];
    if (this.errors.length > 0) {
      for (const error of this.errors) {
        errorMessages.push(error.message);
      }
    } else if ((this.errors as any)['message'] !== undefined) {
      errorMessages.push((this.errors as any)['message']);
    }

    for (const errorMessage of errorMessages) {
      if (errorMessage !== '') {
        showToast(errorMessage, 'error');
      }
    }
  }

  static displayError(errorMsg: string): void {
    if (errorMsg !== '') {
      showToast(errorMsg, 'error');
    }
  }
}
